/** Trims and collapses inner whitespace: "EDP   " → "EDP", "Sport  Tv" → "Sport Tv". */
export function tidyName(value: unknown): string {
  return typeof value === 'string' ? value.replace(/\s+/g, ' ').trim() : '';
}

const NAME_FIELDS = ['brand', 'client', 'influencer', 'campaign_ref'] as const;

/**
 * Normalises the free-text name fields of a campaign payload in place, so
 * "EDP" and "EDP  " stop being two different brands. Empty strings are kept
 * as given (some columns are NOT NULL), null/undefined untouched.
 */
export function normalizeCampaignNames<T extends Record<string, unknown>>(data: T): T {
  for (const key of NAME_FIELDS) {
    const value = data[key];
    if (typeof value === 'string') (data as Record<string, unknown>)[key] = tidyName(value);
  }
  return data;
}
